export const portalRootElementId = "ultimate-portal-root";
export const portalRootElementSelector = `#${portalRootElementId}`;
